<div *ngIf="loading">
  <app-loader></app-loader>
</div>

<div *ngIf="!loading">
  <!-- Search bar -->
  <div
    class="em-c-search-form em-js-header-search menubar-container__searchbar"
  >
    <h4 class="event-name">{{ eventName ? eventName : "All Events" }}</h4>

    <label for="search" class="em-c-search__label em-u-is-vishidden"
      >Search</label
    >
    <div class="em-c-field em-is-readonly">
      <div class="em-c-field__body">
        <input
          class="em-c-input em-js-input"
          placeholder="Search"
          [(ngModel)]="searchString"
        />
        <svg
          class="em-c-icon em-c-icon--medium em-c-field__icon em-u-clickable"
          (click)="clearSearch()"
        >
          <use
            xmlns:xlink="http://www.w3.org/1999/xlink"
            xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#circle-x"
          ></use>
        </svg>
      </div>
    </div>
  </div>

  <div class="filter-section">
    <div class="filter-label">
      <label for="displayOnlySubscribed">Only Subscribe</label>
    </div>
    <input
      class="filter-checkbox"
      id="displayOnlySubscribed"
      type="checkbox"
      [(ngModel)]="displayOnlySubscribed"
    />
  </div>

  <!-- Table of users -->
  <div class="em-c-table-object">
    <div class="em-c-table-object__header"></div>
    <!--end em-c-table-object__header-->
    <div class="em-c-table-object__body">
      <div class="em-c-table-object__body-inner">
        <table class="em-c-table em-c-table--striped">
          <thead class="em-c-table__header">
            <tr class="em-c-table__header-row">
              <th scope="col" class="em-c-table__header-cell">No.</th>
              <th
                scope="col"
                class="em-c-table__header-cell"
                *ngIf="!eventName"
              >
                Event
              </th>
              <th scope="col" class="em-c-table__header-cell">Email Address</th>
              <th scope="col" class="em-c-table__header-cell">Subscribe</th>
            </tr>
            <!-- em-c-table__header-row -->
          </thead>
          <!-- end em-c-table__header -->
          <tbody class="em-c-table__body">
            <tr
              class="em-c-table__row"
              *ngFor="
                let subscription of filter(subscriptions)
                  | userSubscriptionFilter: searchString;
                let index = index
              "
            >
              <td
                class="em-c-table__cell em-js-cell em-js-cell-editable"
                colspan=""
              >
                {{ index + 1 }}
              </td>
              <td
                class="em-c-table__cell em-js-cell em-js-cell-editable"
                colspan=""
                *ngIf="!eventName"
              >
                {{ subscription.eventName }}
              </td>
              <td
                class="em-c-table__cell em-js-cell em-js-cell-editable"
                colspan=""
              >
                {{ subscription.partitionKey }}
              </td>
              <td
                class="em-c-table__cell em-js-cell em-js-cell-editable"
                colspan=""
              >
                <span
                  [ngClass]="{
                    'em-c-badge': true,
                    'em-c-badge--positive': subscription.subscribed,
                    'em-c-badge--negative': !subscription.subscribed
                  }"
                >
                  {{ subscription.subscribed ? "Subscribe" : "Unsubscribe" }}
                </span>
              </td>
            </tr>
            <!-- end em-c-table__row -->
          </tbody>
          <!-- end em-c-table__body -->
        </table>
        <!--end em-c-table-->
      </div>
      <!--end em-c-table-object__body-inner-->
    </div>
    <!--end em-c-table-object__body-->
  </div>
  <!--end em-c-table-object-->
</div>
